<style>
@import './assets/styles/w3.css';
@import './assets/styles/fontawesome.min.css';
@import './assets/styles/rc_main.css';
@import './assets/styles/rc_box.css';
@import './assets/styles/rc_text.css';
@import './assets/styles/rc_input.css';
@import './assets/styles/rc_font.css';
</style>
<template>
  <v-app v-if="userRoles.isAdmin">
    <div v-if="userRoles.isV3">
      <AppHeaderV3 :userInfo="userInfo" :companyInfo="companyInfo" :divisions="divisionList" @navigate="onNavigate"
        @toggleSidebar="handleSidebarToggle" @divisionChanged="handleDivisionChanged"
        @groupChanged="handleGroupChanged" />
      <AppSidebarV3 :is-collapsed="isSidebarCollapsed" :is-owner-or-manager="false" :is-mechanic="false"
        :is-admin="true" :is-local-dev="userRoles.isV3" :features="companyFeatures" @navigate="onNavigate" />
      <v-main>
        <v-alert v-if="(isMissingAddresses || isMissingBilling) && !userRoles.isAdmin" type="warning" variant="tonal"
          class="ma-2 mb-0" border="start">
          <div class="d-flex align-center justify-space-between flex-wrap">
            <div class="mr-2 mb-1 mb-sm-0">
              <strong>Action Required:</strong>
              <span v-if="isMissingAddresses && isMissingBilling" class="text-sm">
                Your Addresses and Billing Information are incomplete.
              </span>
              <span v-else-if="isMissingAddresses" class="text-sm">
                Your Commercially Registered Address and/or HQ Button Address are incomplete.
              </span>
              <span v-else-if="isMissingBilling" class="text-sm">
                Your Billing Information is incomplete.
              </span>
            </div>
            <div class="d-flex ga-2">
              <v-btn v-if="isMissingAddresses" color="warning" variant="elevated" size="small"
                @click="onNavigate({ value: 'company/display', content: 'company', version: 'v3' })">
                Company Settings
              </v-btn>
              <v-btn v-if="isMissingBilling" color="warning" variant="elevated" size="small"
                @click="onNavigate({ value: 'billing/display', content: 'company', version: 'v3' })">
                Billing Settings
              </v-btn>
            </div>
          </div>
        </v-alert>
        <div>
          <router-view />
        </div>
      </v-main>
      <AppFooterV3 :user="auth_user" :client="auth_client" />
    </div>
    <v-main v-else>
      <v-row>
        <v-col :cols="12">
          <app-header />
        </v-col>
      </v-row>
      <v-row v-if="isAdmin">
        <v-col :cols="1">
          <div>
            &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/company/list"
              class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()">Companies</router-link><br>
            &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/invoice/list"
              class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()">Invoices</router-link><br>
            &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/registration/list"
              class="rc-text-small rc-padding-normal rc-border-round"
              onclick="w3_close()">Registrations</router-link><br>
            &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/vehicle/list"
              class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()">Vehicles</router-link><br>
            &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/user/list"
              class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()">Users</router-link><br>
            &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/inspection/list"
              class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()">Inspections</router-link><br>
            &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/hour/list"
              class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()">Hours</router-link><br>
            &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/checklist/list"
              class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()">Checklists</router-link><br>
            &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/report/list"
              class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()">Reports</router-link><br>
            &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/equipment/list"
              class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()">Equipment</router-link><br>
            &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/schedule/list"
              class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()">Schedules</router-link><br>
            &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/card/list"
              class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()">Cards</router-link><br>
            &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/map/list"
              class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()">Map</router-link><br>
            &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/whatsnew"
              class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()">Whats New</router-link><br>
            &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/dashboard"
              class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()">Dashboard</router-link><br>
            &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/stats"
              class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()">Stats</router-link><br>
            &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/blank"
              class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()">Blank</router-link><br>
          </div>
        </v-col>

        <v-col :showBorder="false" :cols="10" :offset="0">
          <v-row>
            <v-col>
              <router-view />
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row v-else>
        <v-col :showBorder="false" :cols="10" :offset="1">
          <v-row>
            <v-col>
              <router-view />
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col :cols="10" offset="1">
          <app-footer />
        </v-col>
      </v-row>

    </v-main>
  </v-app>
  <v-app v-else-if="!userRoles.isV3">
    <v-main>
      <v-row>
        <v-col :cols="12">
          <app-header />
        </v-col>
      </v-row>

      <v-row>
        <v-col :showBorder="false" :cols="10" :offset="1">
          <v-row>
            <v-col>
              <router-view />
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col :cols="10" offset="1">
          <app-footer />
        </v-col>
      </v-row>

    </v-main>
  </v-app>
  <v-app v-else>
    <AppHeaderV3 v-if="showAuthenticatedLayout" :userInfo="userInfo" :companyInfo="companyInfo"
      :divisions="divisionList" @navigate="onNavigate" @toggleSidebar="handleSidebarToggle"
      @divisionChanged="handleDivisionChanged" @groupChanged="handleGroupChanged" />
    <AppSidebarV3 v-if="showAuthenticatedLayout" :is-collapsed="isSidebarCollapsed" :is-mechanic="userRoles.isMechanic"
      :is-owner-or-manager="userRoles.isOwnerOrManager" :is-admin="userRoles.isAdmin" :is-local-dev="userRoles.isV3"
      :features="companyFeatures" @navigate="onNavigate" />
    <v-main>
      <v-alert v-if="isMissingAddresses || isMissingBilling" type="warning" variant="tonal" class="ma-4 mb-0"
        border="start">
        <div class="d-flex align-center justify-space-between flex-wrap">
          <div class="mr-2 mb-2 mb-sm-0">
            <strong>Action Required:</strong>
            <span v-if="isMissingAddresses && isMissingBilling">
              Your Addresses and Billing Information are incomplete.
            </span>
            <span v-else-if="isMissingAddresses">
              Your Commercially Registered Address and/or HQ Button Address are incomplete.
            </span>
            <span v-else-if="isMissingBilling">
              Your Billing Information is incomplete.
            </span>
          </div>
          <div class="d-flex ga-2">
            <v-btn v-if="isMissingAddresses" color="warning" variant="elevated"
              @click="onNavigate({ value: 'company/display', content: 'company', version: 'v3' })">
              Company Settings
            </v-btn>
            <v-btn v-if="isMissingBilling" color="warning" variant="elevated"
              @click="onNavigate({ value: 'billing/display', content: 'company', version: 'v3' })">
              Billing Settings
            </v-btn>
          </div>
        </div>
      </v-alert>
      <div>
        <router-view />
      </div>
    </v-main>
    <AppFooterV3 v-if="showAuthenticatedLayout" :user="auth_user" :client="auth_client" />

    <v-snackbar v-model="updateAvailable" color="info" :timeout="-1" location="bottom right" class="ma-4">
      <div class="d-flex align-center ga-3">
        <v-icon icon="mdi-cloud-download" color="white"></v-icon>
        <div>
          <strong>New version available!</strong>
          <div class="text-caption text-grey-lighten-2">Refresh to load the latest updates.</div>
        </div>
      </div>
      <template v-slot:actions>
        <v-btn color="white" variant="elevated" size="small" class="text-info font-weight-bold" @click="reloadPage">
          Refresh
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>
<script>
import AppFooter from '@/views/app/AppFooter.vue';
import AppHeader from '@/views/app/AppHeader.vue';
import { onMounted } from 'vue';
import { useTheme } from 'vuetify';
import { mapGetters } from 'vuex';
import BooleanUtils from './utils/BooleanUtils';

export default {
  name: 'app',
  components: {
    AppHeader,
    AppFooter,
  },
  data() {
    return {
      error: null,
      isAdmin: false,
    };
  },
  computed: {
    ...mapGetters([
      'auth_user',
      'auth_client',
      'roles_found',
      'user_role',
      'AuthStorage_Company',
      'domain',
    ]),
  },
  watch: {
    AuthStorage_Company() {
      if (!this.domain) {
        this.isAdmin = false;
      } else {
        this.isAdmin = this.domain.session().employee().find().roles().find().isAdministrator();
      }
    },
  },
  methods: {},

};
</script>

<script setup>
import AppFooterV3 from '@/v3/app/AppFooter.vue';
import AppHeaderV3 from '@/v3/app/AppHeader.vue';
import AppSidebarV3 from '@/v3/app/AppSidebar.vue';
import { useCompany } from '@/v3/composables/useCompany';
import { computed, markRaw, ref, watch, onUnmounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useDisplay } from 'vuetify';
import { useStore } from 'vuex';
import StringUtils from './utils/StringUtils';
import { useConnection } from './v3/composables/useConnection';

const router = useRouter();
const route = useRoute();
const store = useStore();
const { mobile } = useDisplay();

const domain = computed(() => store.getters.domain);
const auth_user = computed(() => store.getters.auth_user);
const auth_client = computed(() => store.getters.auth_client);

const {
  log,
} = useConnection(domain);

const savedSidebarState = localStorage.getItem('rc-sidebar-collapsed');
const isSidebarCollapsed = ref(savedSidebarState !== null ? savedSidebarState === 'true' : (mobile ? true : false));
const showAuthenticatedLayout = ref(false);
const { loadCompanyDivisions, loadedCompanyList } = useCompany(domain);

const isMissingAddresses = computed(() => {
  if (!domain.value || !domain.value.session() || !showAuthenticatedLayout.value) return false;
  const company = domain.value.session().company();
  if (!company || company.isNew()) return false;

  const address = company.address().find();
  const hqAddress = company.addressHq().find();

  if (!address || !hqAddress) return true;

  const isAddressMissing = !address.street() || !address.city();
  const isHqMissing = !hqAddress.street() || !hqAddress.city();

  return isAddressMissing || isHqMissing;
});

const isMissingBilling = computed(() => {
  if (!domain.value || !domain.value.session() || !showAuthenticatedLayout.value) return false;
  const company = domain.value.session().company();
  if (!company || company.isNew()) return false;

  const contractStart = company.contractStartDate();
  const now = domain.value.session().time().now();
  const diffMs = now.diff(contractStart);
  const daysUntil = diffMs / (1000 * 60 * 60 * 24);

  if (daysUntil > 5) return false;
  if (daysUntil < -15) return false;

  const settings = company.invoiceSettings().find();
  if (!settings) return true;

  const isInvoiceMissing = !settings.companyName() || !settings.contactName() || !settings.contactEmail();

  const isCardRequired = company.isPaymentMethodCreditCard();
  const isCardMissing = isCardRequired && !company.hasCard();

  return isInvoiceMissing || isCardMissing;
});


const handleSidebarToggle = () => {
  isSidebarCollapsed.value = !isSidebarCollapsed.value;
  localStorage.setItem('rc-sidebar-collapsed', isSidebarCollapsed.value);
};

const handleDivisionChanged = (divisionId) => {
  log.info("Division Changed: {0} route {1}", [divisionId, route.query]);

  const browserStorage = localStorage['readyChek'];
  if (browserStorage) {
    const rcStorage = JSON.parse(browserStorage);
    if (!rcStorage.globalFilters) {
      rcStorage['globalFilters'] = {};
    }

    rcStorage.globalFilters['division'] = divisionId;
    localStorage['readyChek'] = JSON.stringify(rcStorage);

    store.dispatch('AuthStorage_updateDivisionLabel', divisionId);
  }
};

const handleGroupChanged = (groupId) => {
  log.info("Location Changed: {0}", [groupId]);
  const browserStorage = localStorage['readyChek'];
  if (browserStorage) {
    const rcStorage = JSON.parse(browserStorage);
    if (!rcStorage.globalFilters) {
      rcStorage['globalFilters'] = {};
    }

    rcStorage.globalFilters['location'] = groupId;
    localStorage['readyChek'] = JSON.stringify(rcStorage);

    store.dispatch('AuthStorage_updateGroupLabel', groupId);
  }
}

const userRoles = computed(() => {
  let defaultValue = true;
  const v3 = BooleanUtils.toBoolean(window?.localStorage["v3"] ?? defaultValue);
  if (!domain.value || !domain.value.session()) {
    return { isMechanic: false, isAdmin: false, isV3: v3, isOwnerOrManager: false };
  }
  const employee = domain.value.session().employee();
  const roles = employee ? employee.roles().find() : null;
  return {
    isMechanic: roles ? roles.isMechanic() : false,
    isAdmin: roles ? roles.isAdministrator() : false,
    isOwnerOrManager: roles ? roles.isOwnerOrManager() : false,
    isV3: v3,
  };
});

const companyFeatures = computed(() => {
  if (!domain.value || !domain.value.session()) {
    return {};
  }
  const features = domain.value.session().company().features().find();
  if (!features) return {};

  return {
    inspections: features.allowsInspections(),
    timesheets: features.allowsTimesheets(),
    checklists: features.allowsVehicles(),
    map: features.allowsMap(),
    vehicles: features.allowsVehicles(),
    equipment: features.allowsEquipment(),
    tracking: features.allowsTrackLocation(),
    compliance: features.allowsCompliance(),
    gpsDevice: features.allowsGpsDevice(),
  };
});

const divisionList = computed(() => {
  var list = [];
  for (var index in loadedCompanyList.value) {
    let division = loadedCompanyList.value[index];
    list.push({ name: division.name(), id: division.id(), address: division.address().find().location(), encodedId: division.idEncoded() });
  }
  return list;
});

const companyInfo = computed(() => {
  if (!domain.value || !domain.value.session()) {
    return { name: 'ReadyChek', idEncoded: null, hasMultiple: false, divisionPath: [] };
  }
  const session = domain.value.session();
  const company = session.company();
  const employee = session.employee();
  let path = [];
  let temp = company;
  while (temp && temp.isNotNew()) {
    let list = temp.divisions().sortByName();
    let _name = temp.divisionName();
    path.unshift({
      id: temp.id(),
      idEncoded: temp.idEncoded(),
      name: _name,
      isDivision: temp.isDivision(),
      divisions: markRaw(list),
      parentName: temp.isDivision() ? temp.name() : null,
      locations: temp.labels().data
    });
    if (temp.isDivision()) {
      temp = temp.parent().find();
      if (temp.id() !== employee.company().id()) {
        temp = null;
      }
    } else {
      temp = null;
    }
  }
  if (temp && temp.isNew()) {
    path.unshift({
      id: temp.id(),
      idEncoded: temp.idEncoded(),
      name: temp.name(),
      isDivision: false,
      divisions: [],
      locations: temp.labels().data
    });
  }

  const user = session.user();
  const employees = user ? domain.value.employees().findByUserId(user.id()).list() : [];
  const _name = company ? company.name() : 'ReadyChek';
  const map = {
    name: _name,
    divisionPath: path,
    currentCompany: company.id(),
    idEncoded: company ? company.idEncoded() : null,
    hasMultiple: employees.length > 1,
  };
  return map;
});

const userInfo = computed(() => {
  if (!domain.value || !domain.value.session()) {
    return { firstName: 'Guest', idEncoded: null };
  }
  const user = domain.value.session().user();
  return {
    firstName: user ? user.firstDisplay() : 'Guest',
    idEncoded: user ? user.idEncoded() : null,
  };
});

const AuthStorage_Company = computed(() => store.getters.AuthStorage_Company);
watch(AuthStorage_Company, (newCompany) => {
  let hasCompany = true;
  if (!newCompany) {
    hasCompany = false;
  }
  const isNewCompany = newCompany ? newCompany.isNew() : false;
  showAuthenticatedLayout.value = hasCompany && !isNewCompany;

  if (newCompany != null && newCompany.isNotNew()) {
    if (newCompany.hasFeatureDivisions()) {
      loadCompanyDivisions(newCompany, {})
    }
  }
},
  { immediate: true }
);

const onNavigate = (path) => {
  if (!domain.value || !domain.value.session()) {
    console.error("Cannot navigate: domain or session not available.");
    return;
  }
  let rolePath = 'operator';
  let company = domain.value.session().company();
  let pathValue = path.value;
  let content = path.content;
  let companyId = '';
  let subPath = '';

  if (content === "company" || content === "" || content == undefined) {
    rolePath = "operator/";
    companyId = company.idEncoded();
    if (company.isNew()) {
      return;
    }
    subPath = `${rolePath}${companyId}/${pathValue}`;

  } else if (pathValue.startsWith("accounts/:operatorId")) {
    companyId = company.idEncoded();
    if (company.isNew()) {
      return;
    }
    rolePath = "admin/";
    subPath = `${rolePath}${StringUtils.replace(pathValue, ":operatorId", companyId)}`;

  } else {
    rolePath = "admin";
    pathValue = `${pathValue}`;
    subPath = `${rolePath}/${pathValue}`;
  }

  let newPath = `/portal/v3/${subPath}`;
  if (path['version'] == null || path.version == '') {
    if (path['version'] == null) {
      newPath = `/portal/${rolePath}/${companyId}/${path}`;
    } else {
      newPath = `/portal/${rolePath}/${companyId}/${path.value}`;
    }
  }
  console.log('Navigating to:', newPath);
  router.push({ path: newPath });
};

const theme = useTheme();

const updateAvailable = ref(false);
let lastCheckTime = Date.now();
let updateInterval = null;

const checkUpdate = async () => {
  try {
    const res = await fetch('/version.json?t=' + Date.now());
    if (res.ok) {
      const data = await res.json();
      const currentVersion = process.env.VUE_APP_RC_VERSION;
      if (data.version && currentVersion && data.version !== currentVersion) {
        updateAvailable.value = true;
        return true;
      }
    }
  } catch (err) {
    console.error('Failed to check for version updates:', err);
  }
  return false;
};

const reloadPage = () => {
  const url = new URL(window.location.href);
  url.searchParams.set('t', Date.now().toString());
  window.location.href = url.toString();
};

router.afterEach(() => {
  const now = Date.now();
  if (now - lastCheckTime > 5 * 60 * 1000) {
    lastCheckTime = now;
    checkUpdate();
  }
});

onMounted(() => {
  // Clear the cache-busting query parameter from the URL if present
  const url = new URL(window.location.href);
  if (url.searchParams.has('t')) {
    url.searchParams.delete('t');
    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
  }

  const savedTheme = localStorage.getItem('rc-theme');
  if (savedTheme === 'dark' || savedTheme === 'light') {
    theme.change(savedTheme);
  } else {
    theme.change('light');
  }

  // Initial check on load
  checkUpdate();

  // Poll for updates every 15 minutes
  updateInterval = setInterval(checkUpdate, 15 * 60 * 1000);
});

onUnmounted(() => {
  if (updateInterval) {
    clearInterval(updateInterval);
  }
});
</script>